/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export { ConduitSettingsSizeTagModule } from './conduit-settings-size-tag.module';
export { ConduitSettingsSizeTagComponent } from './conduit-settings-size-tag.component';